module.exports = __webpack_public_path__ + "fonts/NoirPro-Regular.fe706631.woff2";